/* Approved 11 October 2026: selling amounts round down to whole pounds.
 * Supplier reference data and existing Ethnicraft prices remain unchanged. */
window.FultonsSellingPrice = window.FultonsSellingPrice || ((value, preserveEthnicraft = false) => {
  if (preserveEthnicraft || typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return value;
  return Math.floor(value + 1e-9);
});
(() => {
  'use strict';
  const keys = ['fc_min_price', 'fc_max_price'];
  const valid = value => value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0;
  window.FultonsCollectionPriceRange = {
    applyToUrl(url, form) {
      keys.forEach(key => {
        const value = form.querySelector('[name="' + key + '"]')?.value || '';
        if (valid(value)) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
    },
    matches(card, url) {
      const values = keys.map(key => url.searchParams.get(key) || '');
      if (!values.some(valid)) return true;
      const min = valid(values[0]) ? Number(values[0]) : 0;
      const max = valid(values[1]) ? Number(values[1]) : Infinity;
      if (min > max) return true;
      const guide = window.FultonsMenuGuidePrices?.[card.dataset.productId];
      const campaign=window.FultonsNatuzziCampaign,campaignId=card.dataset.parentProductId||card.dataset.productId,base=guide?.price??Number(card.dataset.configurationPrice),rrp=Number(guide?.rrp)||Number(window.FultonsVerifiedRrps?.menu?.[card.dataset.productId]?.[String(base)]);
      const price = window.FultonsSellingPrice(campaign?.eligible(campaignId)?campaign.price(campaignId,rrp,base,guide?.selection):Number(card.dataset.configurationPrice)||guide?.price, (card.dataset.furnitureTags||'').split(',').includes('brand-ethnicraft'));
      return Number.isFinite(price) && price > 0 && price >= min && price <= max;
    },
    filterGrid(grid, url) {
      grid.querySelectorAll('.living-test__card').forEach(card => {
        if (!this.matches(card, url)) card.remove();
      });
    }
  };
})();

(() => {
  'use strict';
  const instances = new WeakMap();
  let nextId = 0;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const interpolate = (template, count) => String(template || '').replace(/__count__|\{\{\s*count\s*\}\}/g, String(count));
  const init = () => {
    const labels = window.FultonsCollectionLabels;
    if (!labels || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    document.querySelectorAll('[data-living-filters]').forEach(form => {
      if (instances.has(form)) {
        instances.get(form)();
        return;
      }
      const root = form.closest('.living-test');
      const selects = ['[data-type]', '[data-brand]', '[data-sort]'].map(selector => form.querySelector(selector)).filter(node => node instanceof HTMLSelectElement);
      if (!root || !selects.length) return;
      const excludedBrands = new Set(['brand-arketipo', 'brand-calia-italia']);
      const pruneBrands = () => form.querySelectorAll('[data-brand] option').forEach(option => { if (excludedBrands.has(option.value)) option.remove(); });
      pruneBrands();
      new MutationObserver(pruneBrands).observe(form, {childList: true, subtree: true});
      const facetLabel = select => select.hasAttribute('data-type') ? labels.productType : select.hasAttribute('data-brand') ? labels.brand : labels.sortBy;
      const rangeSource = ['fc_min_price', 'fc_max_price'].map(name => {
        const input = make('input'); input.type = 'hidden'; input.name = name;
        const value = new URL(location.href).searchParams.get(name) || '';
        input.value = value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
        form.append(input); return input;
      });
      let pendingRange = rangeSource.map(input => input.value);
      let rangeInputs = [];
      let rangeError;
      const id = 'fc-filters-' + (++nextId);
      const toolbar = make('div', 'fc-toolbar');
      const opener = make('button', 'fc-open', labels.allFilters);
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 16 16'); icon.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1 4h14M1 12h14M10 1v6M5 9v6'); path.setAttribute('stroke', 'currentColor');
      icon.append(path); opener.prepend(icon);
      opener.type = 'button';
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', id);
      const active = make('span', 'fc-active');
      const count = make('span', 'fc-count');
      count.setAttribute('aria-live', 'polite');
      toolbar.append(opener, active, count);
      const dialog = make('dialog', 'fc-drawer');
      dialog.id = id;
      dialog.setAttribute('aria-labelledby', id + '-title');
      const head = make('div', 'fc-drawer-head');
      const title = make('h2', '', labels.filterSort);
      title.id = id + '-title';
      const close = make('button', 'fc-close', '×');
      close.setAttribute('aria-label', labels.close);
      close.type = 'button';
      close.autofocus = true;
      head.append(title, close);
      const body = make('div', 'fc-drawer-body');
      const foot = make('div', 'fc-drawer-foot');
      const clear = make('button', 'fc-clear', labels.clear);
      const apply = make('button', 'fc-apply', labels.seeResults);
      clear.type = apply.type = 'button';
      foot.append(clear, apply);
      dialog.append(head, body, foot);
      let pending = new Map();
      let resultSource;
      const syncCount = () => {
        const source = root.querySelector('[data-result-count]') || root.querySelector('.living-test__results p');
        if (source !== resultSource) {
          resultObserver.disconnect();
          resultSource = source;
          if (source) resultObserver.observe(source, {childList: true, characterData: true, subtree: true});
        }
        const total = source?.textContent.match(/\d[\d,]*/)?.[0];
        const next = total ? interpolate(labels.products, total) : '';
        if (count.textContent !== next) count.textContent = next;
        const selected = selects.filter(select => select.value !== select.options[0]?.value).length + (rangeSource.some(input => input.value !== '') ? 1 : 0);
        active.hidden = selected === 0;
        active.textContent = selected ? interpolate(labels.activeFilters, selected) : '';
      };
      const resultObserver = new MutationObserver(syncCount);
      const render = () => {
        body.replaceChildren();
        selects.forEach((select, groupIndex) => {
          const options = [...select.options].filter(option => !option.disabled && !option.hidden && !option.parentElement?.disabled);
          if (!options.length) return;
          const group = make('details', 'fc-filter-group');
          group.open = false;
          const summary = make('summary', '', facetLabel(select));
          group.dataset.facet = select.hasAttribute('data-type') ? 'type' : select.hasAttribute('data-brand') ? 'brand' : 'sort';
          group.append(summary);
          const choices = make('div', 'fc-filter-choices');
          options.forEach((option, optionIndex) => {
            const label = make('label', 'fc-filter-choice');
            const radio = make('input');
            radio.type = 'radio';
            radio.name = id + '-group-' + groupIndex;
            radio.id = id + '-choice-' + groupIndex + '-' + optionIndex;
            radio.value = option.value;
            radio.checked = pending.get(select) === option.value;
            radio.addEventListener('change', () => {
              if (radio.checked) pending.set(select, radio.value);
            });
            label.htmlFor = radio.id;
            label.append(radio, make('span', '', option.textContent.trim()));
            choices.append(label);
          });
          group.append(choices);
          body.append(group);
        });
        const price = make('details', 'fc-filter-group');
        price.dataset.facet = 'price';
        price.append(make('summary', '', labels.price));
        const fields = make('div', 'fc-price-fields');
        rangeInputs = pendingRange.map((value, index) => {
          const label = make('label', '', index === 0 ? labels.minPrice : labels.maxPrice);
          const input = make('input'); input.type = 'number'; input.min = '0'; input.step = 'any';
          input.inputMode = 'decimal'; input.value = value; input.id = id + '-price-' + index;
          label.htmlFor = input.id;
          input.addEventListener('input', () => { pendingRange[index] = input.value; rangeError.hidden = true; });
          label.append(input); fields.append(label); return input;
        });
        rangeError = make('p', 'fc-price-error', labels.priceError);
        rangeError.setAttribute('role', 'alert'); rangeError.hidden = true;
        price.append(fields, rangeError);
        const sortGroup = body.querySelector('[data-facet="sort"]');
        if (sortGroup) sortGroup.before(price); else body.append(price);
      };
      const openDrawer = (facet) => {
        pending = new Map(selects.map(select => [select, select.value]));
        pendingRange = rangeSource.map(input => input.value);
        render();
        if (facet) { const group = body.querySelector('[data-facet="' + facet + '"]'); if (group) group.open = true; }
        dialog.showModal();
        document.documentElement.classList.add('fc-filters-open');
      };
      opener.addEventListener('click', () => openDrawer());
      const quick = make('div', 'fc-quick-controls');
      selects.forEach((select, index) => {
        const button = make('button', 'fc-quick', facetLabel(select));
        button.type = 'button'; button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => openDrawer(select.hasAttribute('data-type') ? 'type' : select.hasAttribute('data-brand') ? 'brand' : 'sort'));
        button.dataset.facet = select.hasAttribute('data-sort') ? 'sort' : ''; quick.append(button);
      });
      const priceQuick = make('button', 'fc-quick', labels.price); priceQuick.type = 'button'; priceQuick.setAttribute('aria-haspopup', 'dialog');
      priceQuick.addEventListener('click', () => openDrawer('price'));
      const quickSort = quick.querySelector('[data-facet="sort"]');
      if (quickSort) quickSort.before(priceQuick); else quick.append(priceQuick);
      count.before(quick);
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('fc-filters-open');
        if (opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      clear.addEventListener('click', () => {
        pending = new Map(selects.map(select => [select, [...select.options].find(option => !option.disabled && !option.hidden && !option.parentElement?.disabled)?.value ?? select.value]));
        pendingRange = ['', ''];
        render();
      });
      apply.addEventListener('click', () => {
        const min = pendingRange[0] === '' ? 0 : Number(pendingRange[0]);
        const max = pendingRange[1] === '' ? Infinity : Number(pendingRange[1]);
        if (rangeInputs.some(input => !input.validity.valid) || !Number.isFinite(min) || min < 0 || max < min) {
          rangeError.hidden = false; rangeError.closest('details').open = true; rangeInputs[0].focus(); return;
        }
        rangeSource.forEach((input, index) => { input.value = pendingRange[index]; });
        selects.forEach(select => {
          const value = pending.get(select);
          if ([...select.options].some(option => option.value === value && !option.disabled && !option.hidden && !option.parentElement?.disabled)) select.value = value;
        });
        syncCount();
        dialog.close();
        form.requestSubmit();
      });
      form.before(toolbar);
      root.append(dialog);
      root.classList.add('fc-collection');
      form.classList.add('fc-source-form');
      instances.set(form, syncCount);
      syncCount();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('fultons:catalogue-updated', init);
  document.addEventListener('fultons:catalogue-ready', init);
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  'use strict';
  const instances = new WeakMap();
  let nextId = 0;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const interpolate = (template, count) => String(template || '').replace(/__count__|\{\{\s*count\s*\}\}/g, String(count));
  const init = () => {
    const labels = window.FultonsCollectionLabels;
    if (!labels || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    document.querySelectorAll('.exdisplay:not(.exdisplay--promotions)').forEach(root => {
      if (instances.has(root)) {
        instances.get(root)();
        return;
      }
      const source = root.querySelector('.exdisplay__filters');
      if (!source?.querySelector('[data-exdisplay-filter]')) return;
      const id = 'fc-clearance-' + (++nextId);
      const toolbar = make('div', 'fc-toolbar');
      const opener = make('button', 'fc-open', labels.allFilters);
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 16 16');
      icon.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1 4h14M1 12h14M10 1v6M5 9v6');
      path.setAttribute('stroke', 'currentColor');
      icon.append(path);
      opener.prepend(icon);
      opener.type = 'button';
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', id);
      const active = make('span', 'fc-active');
      const count = make('span', 'fc-count');
      count.setAttribute('aria-live', 'polite');
      toolbar.append(opener, active, count);
      const dialog = make('dialog', 'fc-drawer');
      dialog.id = id;
      dialog.setAttribute('aria-labelledby', id + '-title');
      const head = make('div', 'fc-drawer-head');
      const title = make('h2', '', labels.filterSort);
      title.id = id + '-title';
      const close = make('button', 'fc-close', '×');
      close.setAttribute('aria-label', labels.close);
      close.type = 'button';
      close.autofocus = true;
      head.append(title, close);
      const body = make('div', 'fc-drawer-body');
      const foot = make('div', 'fc-drawer-foot');
      const clear = make('button', 'fc-clear', labels.clear);
      const apply = make('button', 'fc-apply', labels.seeResults);
      clear.type = apply.type = 'button';
      foot.append(clear, apply);
      dialog.append(head, body, foot);
      const selected = () => source.querySelector('[data-exdisplay-filter][aria-pressed="true"]')?.dataset.exdisplayFilter || 'all';
      let pending = selected();
      const available = () => [...source.querySelectorAll('[data-exdisplay-filter]')].filter(button => {
        const value = button.dataset.exdisplayFilter;
        return !button.disabled && (value === 'all' || [...root.querySelectorAll('.exdisplay__card')].some(card => card.dataset.exdisplayCategory === value));
      });
      const sync = () => {
        const result = source.querySelector('[data-exdisplay-results]')?.textContent.match(/\d[\d,]*/)?.[0];
        const total = result || [...root.querySelectorAll('.exdisplay__card')].filter(card => !card.hidden).length;
        const next = interpolate(labels.products, total);
        if (count.textContent !== next) count.textContent = next;
        const hasFilter = selected() !== 'all';
        active.hidden = !hasFilter;
        active.textContent = hasFilter ? interpolate(labels.activeFilters, 1) : '';
      };
      const render = () => {
        const group = make('details', 'fc-filter-group');
        group.open = true;
        group.append(make('summary', '', labels.productType));
        const choices = make('div', 'fc-filter-choices');
        available().forEach((button, index) => {
          const label = make('label', 'fc-filter-choice');
          const radio = make('input');
          radio.type = 'radio';
          radio.name = id + '-type';
          radio.id = id + '-choice-' + index;
          radio.value = button.dataset.exdisplayFilter;
          radio.checked = pending === radio.value;
          radio.addEventListener('change', () => { if (radio.checked) pending = radio.value; });
          label.htmlFor = radio.id;
          label.append(radio, make('span', '', button.textContent.trim()));
          choices.append(label);
        });
        group.append(choices);
        body.replaceChildren(group);
      };
      opener.addEventListener('click', () => {
        pending = selected();
        render();
        dialog.showModal();
        document.documentElement.classList.add('fc-filters-open');
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('fc-filters-open');
        if (opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      clear.addEventListener('click', () => { pending = 'all'; render(); });
      apply.addEventListener('click', () => {
        available().find(button => button.dataset.exdisplayFilter === pending)?.click();
        sync();
        dialog.close();
      });
      source.before(toolbar);
      root.append(dialog);
      root.classList.add('fc-clearance');
      source.classList.add('fc-source-filters');
      const observer = new MutationObserver(sync);
      observer.observe(source, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed']});
      instances.set(root, sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('fultons:catalogue-updated', init);
  document.addEventListener('fultons:catalogue-ready', init);
  document.addEventListener('shopify:section:load', init);
})();
